(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["announcement-bar"] && !Shopify.designMode) return;
  try {
    
  // Brera · rota los mensajes de la barra de anuncios (el tipo "en movimiento" es solo CSS)
  if (!customElements.get('announcement-bar')) {
    customElements.define(
      'announcement-bar',
      class AnnouncementBar extends HTMLElement {
        connectedCallback() {
          if (this.dataset.mode === 'marquee') return;
          this.slides = Array.from(this.querySelectorAll('.announcement-bar__slide'));
          if (this.slides.length < 2) return;
          this.index = 0;
          this.speed = parseInt(this.dataset.speed, 10) || 5000;
          this.autoplay = this.dataset.autoplay === 'true';

          this.querySelector('[data-prev]')?.addEventListener('click', () => this.go(this.index - 1, true));
          this.querySelector('[data-next]')?.addEventListener('click', () => this.go(this.index + 1, true));
          this.addEventListener('mouseenter', () => this.stop());
          this.addEventListener('mouseleave', () => this.start());

          // En el editor: mostrar el mensaje que se está editando
          document.addEventListener('shopify:block:select', (event) => {
            const i = this.slides.indexOf(event.target);
            if (i > -1) {
              this.stop();
              this.go(i);
            }
          });
          document.addEventListener('shopify:block:deselect', () => this.start());

          this.start();
        }

        disconnectedCallback() {
          this.stop();
        }

        go(i, restart) {
          const total = this.slides.length;
          this.index = (i + total) % total;
          this.slides.forEach((slide, n) => {
            const active = n === this.index;
            slide.hidden = !active;
            slide.classList.toggle('is-active', active);
          });
          if (restart) this.start();
        }

        start() {
          this.stop();
          if (!this.autoplay || window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
          this.timer = setInterval(() => this.go(this.index + 1), this.speed);
        }

        stop() {
          clearInterval(this.timer);
        }
      }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  // Brera · header: fijo al hacer scroll (propio en celular), transparente sobre el banner, desplegables con retraso
  // al cerrar, foto que cambia en la lista con foto, búsqueda y panel lateral (acordeón o deslizante)
  if (!customElements.get('brera-header')) {
    customElements.define(
      'brera-header',
      class BreraHeader extends HTMLElement {
        connectedCallback() {
          this.section = this.closest('.shopify-section') || this;
          this.stickyDesktop = this.dataset.sticky; // none | always | scroll-up
          this.stickyMobile = this.dataset.stickyMobile || 'same';
          this.mobileMq = window.matchMedia('(max-width: 989px)');
          this.transparent = this.dataset.transparent === 'true';
          this.solidScheme = Array.from(this.classList).find((c) => c.startsWith('color-'));
          this.transparentScheme = this.dataset.transparentScheme;
          this.lastY = window.scrollY;

          this.applySticky = this.applySticky.bind(this);
          this.applySticky();
          if (this.mobileMq.addEventListener) this.mobileMq.addEventListener('change', this.applySticky);
          if (this.transparent) this.section.classList.add('is-overlay');

          this.setHeight = this.setHeight.bind(this);
          this.onScroll = this.onScroll.bind(this);
          this.setHeight();
          window.addEventListener('resize', this.setHeight);
          window.addEventListener('scroll', this.onScroll, { passive: true });
          this.onScroll();

          // Panel lateral
          this.drawer = this.querySelector('.header__drawer');
          this.menuButton = this.querySelector('[data-menu-open]');
          this.menuButton?.addEventListener('click', () => this.openDrawer());
          this.drawer?.addEventListener('click', (event) => {
            if (event.target === this.drawer) return this.closeDrawer();
            const next = event.target.closest('[data-drawer-next]');
            if (next) {
              const panel = this.drawer.querySelector('#' + next.dataset.drawerNext);
              if (panel) {
                panel.classList.add('is-active');
                this.drawer.classList.add('has-sub');
                next.setAttribute('aria-expanded', 'true');
                this.lastNext = next;
                panel.querySelector('[data-drawer-back]')?.focus({ preventScroll: true });
              }
              return;
            }
            if (event.target.closest('[data-drawer-back]')) return this.closePanels(true);
            if (event.target.closest('[data-menu-close]')) this.closeDrawer();
          });
          this.drawer?.addEventListener('cancel', (event) => {
            event.preventDefault();
            this.closeDrawer();
          });

          // Desplegables de computador: se abren al pasar el mouse y se cierran con un pequeño retraso
          this.overlay = this.querySelector('.header__overlay');
          this.parents = Array.from(this.querySelectorAll('.header__nav--desktop .header-menu__item--parent'));
          if (this.parents.length) {
            this.setAttribute('data-menu-js', '');
            this.parents.forEach((item) => {
              item.addEventListener('pointerenter', (e) => {
                if (e.pointerType === 'touch') return;
                clearTimeout(this.menuTimer);
                this.openItem(item);
              });
              item.addEventListener('pointerleave', (e) => {
                if (e.pointerType === 'touch') return;
                clearTimeout(this.menuTimer);
                this.menuTimer = setTimeout(() => this.closeItems(), 260);
              });
              // Pantallas táctiles grandes (tablet): el primer toque abre, el segundo entra
              item.querySelector(':scope > .header-menu__link')?.addEventListener('click', (e) => {
                if (this.lastPointer === 'touch' && !item.classList.contains('is-open')) {
                  e.preventDefault();
                  this.openItem(item);
                }
              });
            });
            this.addEventListener('pointerdown', (e) => { this.lastPointer = e.pointerType; }, { passive: true });
            document.addEventListener('pointerdown', (e) => {
              if (!this.contains(e.target)) this.closeItems();
            }, { passive: true });
            this.addEventListener('keydown', (e) => {
              if (e.key === 'Escape') this.closeItems();
            });
          }

          // Lista con foto: al pasar por un enlace se muestra su foto
          this.onHoverLink = (e) => {
            const link = e.target.closest && e.target.closest('a[data-hover-index]');
            if (!link) return;
            const box = link.closest('[data-menu-hover]');
            const img = box && box.querySelector('.menu-hover__img[data-hover-index="' + link.dataset.hoverIndex + '"]');
            if (!img || img.classList.contains('is-empty') || img.classList.contains('is-active')) return;
            box.querySelectorAll('.menu-hover__img.is-active').forEach((el) => el.classList.remove('is-active'));
            img.classList.add('is-active');
          };
          this.addEventListener('mouseover', this.onHoverLink);
          this.addEventListener('focusin', this.onHoverLink);

          // Editor del tema: al seleccionar un bloque "Megamenú" se deja abierto para verlo mientras se edita
          this.onBlockSelect = (event) => {
            const item = event.target.closest?.('.header-menu__item');
            if (!item || !this.contains(item)) return;
            this.querySelectorAll('.header-menu__item.is-open').forEach((el) => el.classList.remove('is-open'));
            item.classList.add('is-open');
          };
          this.onBlockDeselect = () => {
            this.querySelectorAll('.header-menu__item.is-open').forEach((el) => el.classList.remove('is-open'));
          };
          document.addEventListener('shopify:block:select', this.onBlockSelect);
          document.addEventListener('shopify:block:deselect', this.onBlockDeselect);

          // Menú de computador: si no cabe en una línea se oculta y aparece ☰ (ajuste "Si el menú no cabe")
          this.bar = this.querySelector('[data-menu-fit]');
          this.nav = this.querySelector('.header__nav--desktop');
          if (this.bar && this.nav) {
            this.checkMenuFit = () => {
              const list = this.nav.querySelector('.header-menu');
              if (!list || !window.matchMedia('(min-width: 990px)').matches) {
                this.bar.classList.remove('has-menu-overflow');
                return;
              }
              const overflow = list.scrollWidth > this.nav.clientWidth + 1;
              this.bar.classList.toggle('has-menu-overflow', overflow);
            };
            this.checkMenuFit();
            if (document.fonts && document.fonts.ready) document.fonts.ready.then(this.checkMenuFit);
            if ('ResizeObserver' in window) new ResizeObserver(this.checkMenuFit).observe(this.nav);
            window.addEventListener('resize', this.checkMenuFit, { passive: true });
          }

          // Búsqueda (lupa del header y barra de búsqueda del celular)
          this.search = this.querySelector('.header__search');
          this.querySelectorAll('[data-search-open]').forEach((btn) => btn.addEventListener('click', () => this.toggleSearch()));
          this.querySelector('[data-search-close]')?.addEventListener('click', () => this.toggleSearch(false));
          this.querySelectorAll('[data-search-backdrop]').forEach((el) => el.addEventListener('click', () => this.toggleSearch(false)));
          this.search?.addEventListener('keydown', (e) => { if (e.key === 'Escape') { this.toggleSearch(false); this.querySelector('[data-search-open]')?.focus(); } });
        }

        disconnectedCallback() {
          window.removeEventListener('resize', this.setHeight);
          window.removeEventListener('scroll', this.onScroll);
          if (this.mobileMq && this.mobileMq.removeEventListener) this.mobileMq.removeEventListener('change', this.applySticky);
          document.removeEventListener('shopify:block:select', this.onBlockSelect);
          document.removeEventListener('shopify:block:deselect', this.onBlockDeselect);
        }

        applySticky() {
          const mobile = this.mobileMq.matches;
          this.sticky = mobile && this.stickyMobile !== 'same' ? this.stickyMobile : this.stickyDesktop;
          this.section.classList.toggle('is-sticky', this.sticky !== 'none');
          if (this.sticky !== 'scroll-up') this.section.classList.remove('is-hidden');
        }

        setHeight() {
          document.documentElement.style.setProperty('--header-height', this.offsetHeight + 'px');
          this.section.style.setProperty('--header-height', this.offsetHeight + 'px');
        }

        onScroll() {
          const y = window.scrollY;

          if (this.transparent) {
            const solid = y > 40 || (this.search && !this.search.hidden) || this.classList.contains('menu-open');
            this.classList.toggle('is-transparent', !solid);
            // Primero se quita uno y luego se pone el otro: así funciona aunque los dos esquemas sean el mismo
            if (this.transparentScheme && this.solidScheme) {
              this.classList.remove(solid ? this.transparentScheme : this.solidScheme);
              this.classList.add(solid ? this.solidScheme : this.transparentScheme);
            }
          }

          if (this.sticky === 'scroll-up') {
            const goingDown = y > this.lastY && y > this.offsetHeight;
            this.section.classList.toggle('is-hidden', goingDown);
          }

          if (this.classList.contains('menu-open')) this.placeOverlay();
          this.lastY = y;
        }

        placeOverlay() {
          if (this.overlay) this.style.setProperty('--header-overlay-top', Math.max(0, this.getBoundingClientRect().bottom) + 'px');
        }

        openItem(item) {
          this.querySelectorAll('.header-menu__item.is-open').forEach((el) => {
            if (el !== item) {
              el.classList.remove('is-open');
              el.querySelector(':scope > .header-menu__link')?.setAttribute('aria-expanded', 'false');
            }
          });
          item.classList.add('is-open');
          item.querySelector(':scope > .header-menu__link')?.setAttribute('aria-expanded', 'true');
          this.classList.add('menu-open');
          this.placeOverlay();
          if (this.transparent) this.onScroll();
        }

        closeItems() {
          clearTimeout(this.menuTimer);
          this.querySelectorAll('.header-menu__item.is-open').forEach((el) => {
            el.classList.remove('is-open');
            el.querySelector(':scope > .header-menu__link')?.setAttribute('aria-expanded', 'false');
          });
          this.classList.remove('menu-open');
          if (this.transparent) this.onScroll();
        }

        closePanels(focusBack) {
          if (!this.drawer) return;
          this.drawer.querySelectorAll('[data-drawer-panel].is-active').forEach((p) => p.classList.remove('is-active'));
          this.drawer.classList.remove('has-sub');
          if (this.lastNext) {
            this.lastNext.setAttribute('aria-expanded', 'false');
            if (focusBack) this.lastNext.focus({ preventScroll: true });
          }
        }

        openDrawer() {
          if (!this.drawer) return;
          this.drawer.showModal();
          // El foco va al panel (no a la X) para que no aparezca el recuadro de foco al abrir con el dedo
          this.drawer.focus({ preventScroll: true });
          requestAnimationFrame(() => this.drawer.classList.add('is-open'));
          this.menuButton?.setAttribute('aria-expanded', 'true');
        }

        closeDrawer() {
          if (!this.drawer) return;
          this.drawer.classList.remove('is-open');
          this.menuButton?.setAttribute('aria-expanded', 'false');
          setTimeout(() => {
            this.drawer.close();
            this.closePanels(false);
          }, 320);
        }

        toggleSearch(force) {
          if (!this.search) return;
          const open = typeof force === 'boolean' ? force : !this.search.classList.contains('is-open');
          if (open) {
            this.search.hidden = false;
            void this.search.offsetWidth;
            this.search.classList.add('is-open');
            this.search.querySelector('input[type="search"]')?.focus();
          } else {
            this.search.classList.remove('is-open');
            setTimeout(() => { if (!this.search.classList.contains('is-open')) this.search.hidden = true; }, 250);
          }
          document.documentElement.classList.toggle('search-open', open);
          this.querySelectorAll('[data-search-open]').forEach((btn) => btn.setAttribute('aria-expanded', String(open)));
          this.onScroll();
        }
      }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
